/**
 * Böngészőbe mentünk adatokat azért, hogy
 * - köszönő oldalon megtudjuk jeleníteni összesítőnézetben a kitöltött adatokat
 * - ne lehessen kitölteni ugyan azt a formot adott időn belül többször
 */
export default [
	function () {
		const MINUTES_IN_MS = 1000 * 60;

		const getExpirationStorageKey = (formId) => {
			return `dynaform_${formId}`;
		};

		const saveFormData = (currentStep, formData) => {
			window.localStorage.setItem(
				'dynaData',
				JSON.stringify({
					pageID: currentStep,
					formData: formData
				})
			);
		};

		const saveCompletedFormExpiration = (formId) => {
			window.localStorage.setItem(getExpirationStorageKey(formId), new Date().getTime());
		};

		const formAlreadyCompleted = (formId) => {
			const formExpirationInMs = window.localStorage.getItem(getExpirationStorageKey(formId));
			const now = new Date().getTime();

			return formExpirationInMs && now - formExpirationInMs < MINUTES_IN_MS;
		};

		const checkExpiredCompletedForms = (formId) => {
			if (formAlreadyCompleted(formId)) {
				window.localStorage.setItem(getExpirationStorageKey(formId), new Date().getTime());
			}
		};

		return {
			saveFormData: saveFormData,
			saveCompletedFormExpiration: saveCompletedFormExpiration,
			checkExpiredCompletedForms: checkExpiredCompletedForms,
			formAlreadyCompleted: formAlreadyCompleted
		};
	}
];
